import { CONTRACTOR_MANAGEMENT_ORG_IDS } from '@watershed/constants/organization';

/**
 * Demo, test, root, and contractor management orgs are not subject to admin controls.
 */
export const isCustomerOrg = (
  org: {
    id: string;
    demoOrg: boolean;
    testOrg: boolean;
    isRoot: boolean;
  },
  deps: {
    contractorManagementOrgIds: typeof CONTRACTOR_MANAGEMENT_ORG_IDS;
  } = {
    contractorManagementOrgIds: CONTRACTOR_MANAGEMENT_ORG_IDS,
  }
): boolean => {
  return (
    !org.demoOrg &&
    !org.testOrg &&
    !org.isRoot &&
    !deps.contractorManagementOrgIds.includes(org.id)
  );
};

export const isDemoOrg = (org: { demoOrg: boolean }): boolean => org.demoOrg;

export const isTestOrg = (org: { testOrg: boolean }): boolean => org.testOrg;

export const isDemoOrTestOrg = (org: {
  demoOrg: boolean;
  testOrg: boolean;
}): boolean => isDemoOrg(org) || isTestOrg(org);

export const userCanAccessOrganization = ({
  canAccessOrganization,
  org,
  deps = {
    contractorManagementOrgIds: CONTRACTOR_MANAGEMENT_ORG_IDS,
  },
}: {
  canAccessOrganization: boolean;
  org: {
    id: string;
    demoOrg: boolean;
    testOrg: boolean;
    isRoot: boolean;
  };
  deps?: {
    contractorManagementOrgIds: typeof CONTRACTOR_MANAGEMENT_ORG_IDS;
  };
}): boolean => {
  return canAccessOrganization || !isCustomerOrg(org, deps);
};
